export default class SiteFooter {
    constructor() {
        this.initDarkmodeSwitcher();
    }

    initDarkmodeSwitcher() {
        const $control = document.getElementById('footerDarkmodeSwitcher');

        if (!$control) return;

        const $input = $control.querySelector('input');
        const cookie = costorage.get('h_darkMode');

        $input.checked = !!(cookie && !!+cookie);

        $input.addEventListener('change', (e) => {
            if (e.target.checked) {
                document.body.classList.add('-darkmode');
                costorage.set('h_darkMode', '1', { expires: (5 * 24 * 60 * 60), path: '/', domain: '.itwiki.dev' });
            } else {
                document.body.classList.remove('-darkmode');
                costorage.set('h_darkMode', '0', { expires: (5 * 24 * 60 * 60), path: '/', domain: '.itwiki.dev' });
            }
        });
    }
}